import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
//Simple bar
import SimpleBar from 'simplebar-react';
// MetisMenu
import MetisMenu from 'metismenujs';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useProfile } from '@/hooks/useProfile';
import { ROUTES } from '@/configs/routesConfig';
import { useTranslation } from 'react-i18next';

const SidebarContent = (props) => {
  const ref = useRef();
  const { t } = useTranslation();

  const activateParentDropdown = useCallback((item) => {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.remove('mm-show');
        }

        parent.classList.remove('mm-active');
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('mm-active'); // li
            parent3.childNodes[0].classList.remove('mm-active');

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove('mm-show'); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('mm-show'); // li
                parent5.childNodes[0].classList.remove('mm-active'); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = props.location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu('#side-menu');
    activeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const { isAdmin, isPsychologist, hasPsychologist, hasNutritionist } = useProfile();
  return (
    <React.Fragment>
      <SimpleBar className="sidebar-menu-scroll" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {isAdmin && (
              <>
                <li className="menu-title" data-key="t-applications">
                  {t('nav.menu_admin')}
                </li>

                <li>
                  <Link to={ROUTES.psychologists}>
                    <i className="icon nav-icon fas fa-user-graduate" />
                    <span className="menu-item">{t('nav.psychologists')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.nutritionists}>
                    <i className="icon nav-icon fas fa-apple-alt" />
                    <span className="menu-item">{t('nutrition.title')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.consultations}>
                    <i className="icon nav-icon fas fa-clipboard-list" />
                    <span className="menu-item">{t('nav.psychologist_consultations')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.nutritionConsultations}>
                    <i className="icon nav-icon fas fa-clipboard-list" />
                    <span className="menu-item">{t('nutrition.consultations')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.scheduler}>
                    <i className="icon nav-icon fas fa-calendar-alt" />
                    <span className="menu-item">{t('nav.scheduler')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.users}>
                    <i className="icon nav-icon fas fa-users" />
                    <span className="menu-item">{t('nav.clients')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.checkouts}>
                    <i className="icon nav-icon fas fa-credit-card" />
                    <span className="menu-item">{t('nav.checkouts')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.pages}>
                    <i className="icon nav-icon fas fa-book-open" />
                    <span className="menu-item">{t('nav.pages')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.seo}>
                    <i className="icon nav-icon fab fa-searchengin"></i>
                    <span className="menu-item">{t('nav.seo')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.callbacks}>
                    <i className="icon nav-icon fas fa-folder-open" />
                    <span className="menu-item">{t('nav.callbacks')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.feedbacks}>
                    <i className="icon nav-icon fas fa-comments" />
                    <span className="menu-item">{t('nav.feedbacks')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.nutritionFeedbacks}>
                    <i className="icon nav-icon fas fa-comments" />
                    <span className="menu-item">{t('nutrition.feedbacks')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.centers}>
                    <i className="icon nav-icon fas fa-building" />
                    <span className="menu-item">{t('nav.centers')}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to={ROUTES.problems}>
                    <i className="icon nav-icon fas fa-filter" />
                    <span className="menu-item">{t('nav.problems')}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to={ROUTES.filters}>
                    <i className="icon nav-icon fas fa-filter" />
                    <span className="menu-item">{t('nav.filters')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.nutritionFilters}>
                    <i className="icon nav-icon fas fa-filter" />
                    <span className="menu-item">{t('nutrition.filters')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.promos}>
                    <i className="icon nav-icon fa fa-percent" />
                    <span className="menu-item">{t('nav.promos')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.banners}>
                    <i className="icon nav-icon fa fa-tags" />
                    <span className="menu-item">{t('nav.banners')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.features}>
                    <i className="icon nav-icon fa fa-list" />
                    <span className="menu-item">{t('nav.features')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.nutritionFeatures}>
                    <i className="icon nav-icon fa fa-list" />
                    <span className="menu-item">{t('nutrition.features')}</span>
                  </Link>
                </li>
              </>
            )}
            {isPsychologist && (
              <>
                <li className="menu-title" data-key="t-applications">
                  {t('nav.menu_psychologist')}
                </li>

                {hasPsychologist && <li>
                  <Link to={ROUTES.consultations}>
                    <i className="icon nav-icon fas fa-clipboard-list" />
                    <span className="menu-item">{t('nav.psychologist_consultations')}</span>
                  </Link>
                </li>}
                {hasNutritionist && <li>
                  <Link to={ROUTES.nutritionConsultations}>
                    <i className="icon nav-icon fas fa-clipboard-list" />
                    <span className="menu-item">{t('nutrition.specialist_consultations')}</span>
                  </Link>
                </li>}
                <li>
                  <Link to={ROUTES.scheduler}>
                    <i className="icon nav-icon fas fa-calendar-alt" />
                    <span className="menu-item">{t('nav.scheduler')}</span>
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.users}>
                    <i className="icon nav-icon fas fa-users" />
                    <span className="menu-item">{t('nav.clients')}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to={ROUTES.pages}>
                    <i className="icon nav-icon fas fa-newspaper" />
                    <span className="menu-item">{t('nav.blog')}</span>
                  </Link>
                </li> */}
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};
SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(SidebarContent);
